import { render } from "./Calculator.vue?vue&type=template&id=104f15d0&scoped=true&ts=true"
import script from "./Calculator.vue?vue&type=script&lang=ts"
export * from "./Calculator.vue?vue&type=script&lang=ts"

import "./Calculator.vue?vue&type=style&index=0&id=104f15d0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104f15d0"]])

export default __exports__